import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/weak-map';
import Pusher from 'pusher-js';
import React from 'react';
import ReactDOM from 'react-dom';
import WidgetApp from 'src/javascripts/components/widget/WidgetApp';
import { setupTranslations } from 'src/javascripts/services/translations';
import WidgetMessageService from 'src/javascripts/services/widget-message-service';
import '../src/javascripts/ie_check';

const loadWidgetApp = () => {
  const config = window.CityMessenger.widgetConfig;
  const pusher = config.pusher = new Pusher(config.pusherKey, { cluster: 'eu', forceTLS: true });
  const messageService = new WidgetMessageService(config.shops, pusher);
  const renderCanvas = config.renderCanvas !== 'false';
  const transparentBackground = config.transparentBackground === 'true';
  setupTranslations();

  ReactDOM.render(
    (
      <WidgetApp
        {...config}
        messageService={messageService}
        renderCanvas={renderCanvas}
        transparentBackground={transparentBackground}
      />
    ),
    document.getElementById('widget-app'),
  );

  if (transparentBackground) {
    document.body.classList.add('bg-transparent');
  }
};

const showIEWarning = () => {
  document.querySelector('.ie-warning').classList.add('needed');
};

document.addEventListener('DOMContentLoaded', window.CityMessenger.isIE ? showIEWarning : loadWidgetApp);
